import _cloneDeep from 'lodash/cloneDeep'

import {
  GET_LASTTRANSACTION_REQUESTED,
  GET_LASTTRANSACTION_SUCCESS,
  GET_LASTTRANSACTION_FAILED,
  GET_LASTTRANSACTIONBATCH_REQUESTED,
  GET_LASTTRANSACTIONBATCH_SUCCESS,
  GET_LASTTRANSACTIONBATCH_FAILED,
  EDIT_TRANSACTION_REQUESTED,
  EDIT_TRANSACTION_SUCCESS,
  EDIT_TRANSACTION_FAILED,
  RESET_TRANSACTIONS
} from '../actions/actionTypes'

const initialState = {
  lastTransaction: undefined,
  lastTransactionLoading: false,
  commonError: false,
  lastTransactionBatch: undefined,
  lastTransactionBatchLoading: false,
  editTransaction: undefined,
  editTransactionLoading: false,
}

const transactionsReducer = (state = _cloneDeep(initialState), action) => {
  switch (action.type) {
    case GET_LASTTRANSACTION_REQUESTED:
      return {
        ...state,
        lastTransactionLoading: true,
        commonError: false
      }
    case GET_LASTTRANSACTION_SUCCESS:
      return {
        ...state,
        lastTransactionLoading: false,
        lastTransaction: action.payload
      }
    case GET_LASTTRANSACTION_FAILED:
      return {
        ...state,
        lastTransactionLoading: false,
        commonError: action.payload
      }
    case GET_LASTTRANSACTIONBATCH_REQUESTED:
      return {
        ...state,
        lastTransactionBatchLoading: true,
        commonError: false
      }
    case GET_LASTTRANSACTIONBATCH_SUCCESS:
      return {
        ...state,
        lastTransactionBatchLoading: false,
        lastTransactionBatch: action.payload
      }
    case GET_LASTTRANSACTIONBATCH_FAILED:
      return {
        ...state,
        lastTransactionBatchLoading: false,
        commonError: action.payload
      }
    case EDIT_TRANSACTION_REQUESTED:
      return {
        ...state,
        editTransactionLoading: true,
        commonError: false
      }
    case EDIT_TRANSACTION_SUCCESS:
      return {
        ...state,
        editTransactionLoading: false,
        editTransaction: action.payload
      }
    case EDIT_TRANSACTION_FAILED:
      return {
        ...state,
        editTransactionLoading: false,
        commonError: action.payload
      }
    case RESET_TRANSACTIONS:
      return _cloneDeep(initialState)
      
    default:
      return state
  }
}

export default transactionsReducer
